import { Link } from "@tanstack/react-router";
import { useBrandLogoUrl } from "@/branding/BrandingProvider";
import { useTranslation } from "react-i18next";

const LAST_UPDATED = "09.06.2026";

export function ImpressumPage() {
  const { t } = useTranslation("common");
  const primaryLogoUrl = useBrandLogoUrl("primary");

  const imprintLabel = t("footer.imprint");
  const privacyPolicyLabel = t("footer.privacyPolicy");

  return (
    <div className="min-h-screen client-gradient-bg flex flex-col">
      <header className="p-4 sm:p-6">
        <img
          src={primaryLogoUrl}
          alt="JourFx"
          className="h-8 sm:h-10 lg:h-12 w-auto"
        />
      </header>

      <main className="flex-1 flex items-center justify-center p-4 sm:p-6">
        <div className="w-full max-w-3xl">
          <div className="client-card p-6 sm:p-8">
            <h1 className="text-2xl sm:text-3xl font-bold text-[var(--stone-800)]">
              Impressum
            </h1>
            <p className="mt-2 text-sm text-[var(--stone-500)]">
              Stand: {LAST_UPDATED}
            </p>

            <div className="mt-6 space-y-6 text-[var(--stone-700)] leading-relaxed">
              <section className="space-y-2">
                <h2 className="text-lg font-semibold text-[var(--stone-800)]">
                  Anbieterkennzeichnung
                </h2>
                <div className="text-sm space-y-1">
                  <p><span className="font-semibold">Diensteanbieter:</span> Medizinischer Dienst Berlin-Brandenburg</p>
                  <p><span className="font-semibold">Anschrift:</span> Schlaatzweg 1, 14473 Potsdam</p>
                  <p><span className="font-semibold">Vertreten durch:</span> Dr. med. Axel Meeßen, Vorstandsvorsitzender</p>
                  <p><span className="font-semibold">Telefon:</span> 0331 50567-0</p>
                  <p><span className="font-semibold">Telefax:</span> 0331 50567-11</p>
                  <p><span className="font-semibold">E-Mail:</span> info(at)md-bb.org</p>
                </div>
                <p className="text-sm text-[var(--stone-600)]">
                  Dieses Portal dient der Terminorganisation und Teilnahme an Videobegutachtungen des Medizinischen Dienstes Berlin-Brandenburg.
                </p>
              </section>

              <section className="space-y-2">
                <h2 className="text-lg font-semibold text-[var(--stone-800)]">
                  Verantwortlich im Sinne des Presserechts
                </h2>
                <div className="text-sm space-y-1">
                  <p>Dr. med. Axel Meeßen</p>
                  <p>Vorstandsvorsitzender des Medizinischen Dienstes Berlin-Brandenburg</p>
                  <p>Schlaatzweg 1, 14473 Potsdam</p>
                </div>
              </section>

              <section className="space-y-2">
                <h2 className="text-lg font-semibold text-[var(--stone-800)]">
                  Aufsicht
                </h2>
                <p className="text-sm text-[var(--stone-600)]">
                  Die Aufsicht nach § 280 Abs. 4 SGB V liegt beim Ministerium für Arbeit, Soziales, Gesundheit und gesellschaftlichen Zusammenhalt des Landes Brandenburg.
                </p>
              </section>

              <section className="space-y-2">
                <h2 className="text-lg font-semibold text-[var(--stone-800)]">
                  Datenschutzkontakt
                </h2>
                <p className="text-sm text-[var(--stone-600)]">
                  Datenschutzbeauftragter des Medizinischen Dienstes Berlin-Brandenburg: Heiko Klatt, Lise-Meitner-Straße 1, 10589 Berlin.
                  Telefon: 030 202023-5030. Telefax: 030 202023-5032. E-Mail: datenschutz(at)md-bb.org.
                </p>
              </section>

              <section className="space-y-2">
                <h2 className="text-lg font-semibold text-[var(--stone-800)]">
                  Technische Bereitstellung
                </h2>
                <p className="text-sm text-[var(--stone-600)]">
                  Das Videobegutachtungsportal wird technisch auf Basis von JourFx bereitgestellt. JourFx ist eine Plattform der Spektrum Gruppe GmbH.
                  Die technische Verarbeitung erfolgt im Auftrag des Medizinischen Dienstes Berlin-Brandenburg.
                </p>
              </section>

              <section className="space-y-2">
                <h2 className="text-lg font-semibold text-[var(--stone-800)]">
                  Hinweis zur Nutzung
                </h2>
                <p className="text-sm text-[var(--stone-600)]">
                  Dieses Portal dient der Teilnahme an einer geplanten Videobegutachtung bzw. der Terminorganisation.
                  Es ist kein Notfalldienst. In medizinischen Notfällen wählen Sie bitte die 112.
                </p>
              </section>
            </div>

            <div className="mt-8 flex flex-wrap gap-3">
              <Link
                to="/"
                className="client-footer-link text-sm font-medium"
              >
                {t("nav.toHome")}
              </Link>
              <span className="text-[var(--stone-300)]" aria-hidden="true">|</span>
              <Link to="/datenschutz" className="client-footer-link text-sm font-medium">
                {privacyPolicyLabel}
              </Link>
            </div>
          </div>
        </div>
      </main>

      <footer className="client-footer relative z-10">
        <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-2">
          <Link to="/datenschutz" className="client-footer-link">{privacyPolicyLabel}</Link>
          <span className="text-[var(--stone-300)]" aria-hidden="true">|</span>
          <Link to="/impressum" className="client-footer-link">{imprintLabel}</Link>
        </div>
      </footer>
    </div>
  );
}
